<template>
  <div
    class="flex items-center justify-center text-2xl font-bold h-full md:hidden"
    :class="{
      'pb-[36px]': isCordovaApk,
    }"
  >
    <!-- <div class="w-[240px] h-[240px]" v-if="!isCordovaApk">
      <img src="/images/icons/logo-pwa-dark.svg" alt="" />
    </div> -->
    <!-- <div class="w-[300px] h-[300px]" v-if="!isCordovaApk">
      <img src="/images/icons/logo-pwa-dark.svg" alt="" />
    </div>
    <div class="w-[275px] h-[275px]" v-else>
      <img src="/images/icons/splashIconSource.svg" alt="" />
    </div> -->
    <Loader />
  </div>
</template>

<script>
import Loader from '../utils/Loader.vue'

export default {
  components: { Loader },
  name: 'SplashComponent',
  data() {
    return {}
  },
  mounted() {},
  methods: {},
  computed: {
    isCordovaApk() {
      return true
      let isClient = false
      try {
        if (window) isClient = true
      } catch (error) {
        console.log(error)
      }
      if (!isClient) return true
      return !!window.isCordovaApk
    },
  },
}
</script>
